module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAVCAYAAABLy77vAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACoSURBVHgB7ZFdDYUwDIUrAQmTcCUgpRJwcCcBB0hBAhKQgISxJQcoS1cCeyLhJH3o35f1jEIIvxhjjIYgrXYpLCRNaRGQBbXuDqgBZI7h0jIg3thxFsyJvDUg24uHUvMvcq/5k50dTrCs2QKye1aY69E/YMJsT2fPdrMziDY3bAVWPOPCOdrvMllSIBJWDZH6IO+FANRVQwTMV0MMGNNTCRhTrZL59EArKzWwGFUNa+gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-six/ser.png
// module id = jlxK
// module chunks = 0